module.exports = __webpack_public_path__ + "static/media/hexagon-landing-page.03db1b95.jpg";